import React from "react";
import { Link } from "react-router-dom";

export default function MarketingFooter() {
  return (
    <footer className="site-footer-dark" data-testid="marketing-footer">
      <div className="max-w-[1180px] mx-auto px-6">
        <div className="footer-grid">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4" style={{ color: "white", fontWeight: 600 }}>
              <span className="brand-mark inverted">A</span>
              <span style={{ fontSize: 16, letterSpacing: "-0.01em" }}>AnswerWatch</span>
            </Link>
            <p style={{ color: "#8a857a", fontSize: 14, maxWidth: 280, margin: 0 }}>
              Rank tracking for AI answer engines. Built for founders and growth teams in the post-search era.
            </p>
          </div>
          <div>
            <h4>Product</h4>
            <ul>
              <li><Link to="/#features" data-testid="footer-features">Features</Link></li>
              <li><Link to="/pricing" data-testid="footer-pricing">Pricing</Link></li>
              <li><Link to="/atlas" data-testid="footer-atlas">Free Atlas</Link></li>
              <li><Link to="/#how" data-testid="footer-how">How it works</Link></li>
            </ul>
          </div>
          <div>
            <h4>Use cases</h4>
            <ul>
              <li><Link to="/#features">For founders</Link></li>
              <li><Link to="/#features">For agencies</Link></li>
              <li><Link to="/#features">For SEO teams</Link></li>
              <li><Link to="/#features">For PR teams</Link></li>
            </ul>
          </div>
          <div>
            <h4>Resources</h4>
            <ul>
              <li><Link to="/atlas">AI Visibility Atlas</Link></li>
              <li><Link to="/#faq">FAQ</Link></li>
              <li><Link to="/#features">GEO playbook</Link></li>
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/login">Sign in</Link></li>
              <li><Link to="/login">Open app</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-meta">
          <span>© 2026 AnswerWatch · Built for the answer era</span>
          <span style={{ display: "flex", gap: 16 }}>
            <a href="#" style={{ color: "#8a857a" }}>Privacy</a>
            <a href="#" style={{ color: "#8a857a" }}>Terms</a>
            <a href="#" style={{ color: "#8a857a" }}>Security</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
